const strings = {
  DELETE_ACCOUNT: {
    SE: 'Radera konto',
    EN: 'Delete account'
  },
  PASSWORD: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  CONFIRM_DELETE: {
    SE: 'Bekräfta radering',
    EN: 'Confirm deletion'
  },
  CANCEL: {
    SE: 'Avbryt',
    EN: 'Cancel'
  },
  MANDATORY_FIELD: {
    SE: 'Obligatoriskt fält',
    EN: 'Mandatory field'
  },
  INCORRECT_PASSWORD: {
    SE: 'Fel lösenord, försök igen.',
    EN: 'Incorrect password, please try again.'
  },
  INTERNAL_ERROR: {
    SE: 'Ett oväntat fel har uppstått, var god försök igen.',
    EN: 'An unexpected error has occured, please try again.'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/DeleteAccountModal/strings.js